export default __webpack_public_path__ + "static/media/doodle_left.f9d37062.png";